import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `Date` scalar type represents a date in the format ISO 8601. */
  Date: string
  /** Represents UTC date/time as milliseconds since the Unix epoch. */
  DateTimeMillis: number
  /** Represents a decimal number in string format. */
  Decimal: string
  /** Represents a specific year and month using the format "YYYY-MM". */
  RewardsPeriod: string
}

export type AccountDocument = {
  __typename?: 'AccountDocument'
  /** The type of the document. */
  documentType: AccountDocumentType
  /** The name of the file. */
  fileName: Scalars['String']
  /** The date and time the account document was last updated. */
  updatedAt: Scalars['DateTimeMillis']
}

export const AccountDocumentType = {
  TaxExemption: 'TAX_EXEMPTION',
  W9TaxId: 'W9_TAX_ID',
} as const

export type AccountDocumentType = (typeof AccountDocumentType)[keyof typeof AccountDocumentType]
export const AccountType = {
  Checking: 'CHECKING',
  Savings: 'SAVINGS',
} as const

export type AccountType = (typeof AccountType)[keyof typeof AccountType]
export type AutoCompleteInput = {
  limit?: InputMaybe<Scalars['Int']>
  query: Scalars['String']
}

export type AutoCompleteResults = {
  __typename?: 'AutoCompleteResults'
  aggregations: AutoCompleteResultsAggregations
  limit: Scalars['Int']
  query: Scalars['String']
  results: Array<IndexedProduct>
  suggestions: Array<Scalars['String']>
  totalCount: Scalars['Int']
}

export type AutoCompleteResultsAggregation = {
  __typename?: 'AutoCompleteResultsAggregation'
  id: Scalars['String']
  label?: Maybe<Scalars['String']>
  options: Array<AutoCompleteResultsAggregationOption>
}

export type AutoCompleteResultsAggregationOption = {
  __typename?: 'AutoCompleteResultsAggregationOption'
  count?: Maybe<Scalars['Int']>
  label?: Maybe<Scalars['String']>
  value: Scalars['ID']
}

export type AutoCompleteResultsAggregations = {
  __typename?: 'AutoCompleteResultsAggregations'
  category?: Maybe<AutoCompleteResultsAggregation>
}

/** The auto ship interval options. */
export const AutoShipOption = {
  Months_1: 'MONTHS_1',
  Months_2: 'MONTHS_2',
  Months_3: 'MONTHS_3',
} as const

export type AutoShipOption = (typeof AutoShipOption)[keyof typeof AutoShipOption]
/** Single bucket in an aggregation (similar to a filter option) */
export type BucketValue = {
  __typename?: 'BucketValue'
  /** The number of results in the bucket */
  count: Scalars['Int']
  /** The aggregation bucket name/value */
  value: Scalars['String']
}

export type CommissionsPayout = {
  __typename?: 'CommissionsPayout'
  success: Scalars['Boolean']
}

export type CreateEScriptInput = {
  /** The description of the eScript. */
  description?: InputMaybe<Scalars['String']>
  /** The name of the eScript. */
  name: Scalars['String']
  /**
   * The products in the eScript.
   * The sku should be unique within an eScript.
   */
  products: Array<NewEScriptProduct>
  /**
   * The public promo code that is used by a customer to get the discount.
   * Empty string or null means no promo code.
   */
  promoCode?: InputMaybe<Scalars['String']>
}

/** The standard ISO 4217 currency codes that represent the currencies used. */
export const CurrencyCode = {
  Cad: 'CAD',
  Usd: 'USD',
} as const

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode]
/** Custom packet configuration */
export type CustomPacketOrderConfigInput = {
  /** Contents of each packet */
  contents: Array<CustomPacketOrderContentInput>
  /** Instructions to print on the packet */
  dosageInstructions: Scalars['String']
}

/** Custom packet contents */
export type CustomPacketOrderContentInput = {
  /** The DFH product name */
  dfhName: Scalars['String']
  /** Per-capsule price of the product */
  perCapsulePrice: Scalars['Decimal']
  /** Private label name to use */
  privateLabelName: Scalars['String']
  /** Per-packet quantity of the product */
  quantity: Scalars['Int']
  /** The SKU of the product */
  sku: Scalars['String']
}

/** Packet configurations for a custom packet order */
export type CustomPacketOrderPacketsInput = {
  /** Morning (am) packet configuration */
  am?: InputMaybe<CustomPacketOrderConfigInput>
  /** Daily packet configuration */
  daily?: InputMaybe<CustomPacketOrderConfigInput>
  /** Evening (pm) packet configuration */
  pm?: InputMaybe<CustomPacketOrderConfigInput>
}

export type CustomPacketOrderRequest = {
  __typename?: 'CustomPacketOrderRequest'
  requestedAt: Scalars['DateTimeMillis']
}

export type Customer = {
  __typename?: 'Customer'
  accountDocument: Array<AccountDocument>
  availableBalance?: Maybe<CustomerAvailableBalance>
  id: Scalars['ID']
  orderByNumber?: Maybe<Order>
  orders: OrderConnection
  payoutMethod?: Maybe<PayoutMethod>
  rewardsPeriods: Array<Scalars['RewardsPeriod']>
  rewardsSnapshotByPeriod?: Maybe<RewardsSnapshot>
  /**
   * A list of rewards snapshots for the customer.
   * Only supports last:6. Any other pagination will result in an error.
   */
  rewardsSnapshots?: Maybe<RewardsSnapshotConnection>
  rewardsTransaction?: Maybe<RewardsTransaction>
  rewardsTransactions?: Maybe<RewardsTransactionConnection>
}

export type CustomerOrderByNumberArgs = {
  orderNumber: Scalars['String']
}

export type CustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type CustomerRewardsSnapshotByPeriodArgs = {
  period: Scalars['RewardsPeriod']
}

export type CustomerRewardsSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type CustomerRewardsTransactionArgs = {
  id: Scalars['ID']
}

export type CustomerRewardsTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  classification?: InputMaybe<Array<RewardsTransactionClassification>>
  dateRange?: InputMaybe<DateRangeInput>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

export type CustomerAvailableBalance = {
  __typename?: 'CustomerAvailableBalance'
  commissionsBalance: Money
  rebateBalance: Money
  storeCredit: Money
  totalBalance: Money
}

export const CustomerOrderTag = {
  AutoShip: 'AUTO_SHIP',
  GeneratedLead: 'GENERATED_LEAD',
} as const

export type CustomerOrderTag = (typeof CustomerOrderTag)[keyof typeof CustomerOrderTag]
/** Input type for specifying a date range. */
export type DateRangeInput = {
  /** The end date of the range (inclusive). */
  end: Scalars['Date']
  /** The start date of the range (inclusive). */
  start: Scalars['Date']
}

export type DeleteAccountDocumentPayload = {
  __typename?: 'DeleteAccountDocumentPayload'
  /** Date and time the account document was deleted. */
  deletedAt: Scalars['DateTimeMillis']
}

export type DeleteEScriptPayload = {
  __typename?: 'DeleteEScriptPayload'
  /**
   * The id of the removed eScript.
   * If the eScript was not found, this will be null.
   */
  id?: Maybe<Scalars['ID']>
}

export type DeletePayoutMethodPayload = {
  __typename?: 'DeletePayoutMethodPayload'
  /** Date and time the payout method was deleted. */
  deletedAt: Scalars['DateTimeMillis']
}

export const DigitalWallet = {
  ApplePay: 'APPLE_PAY',
  GooglePay: 'GOOGLE_PAY',
} as const

export type DigitalWallet = (typeof DigitalWallet)[keyof typeof DigitalWallet]
/** Practitioner-specific context for patient shopping */
export type Dispensary = {
  __typename?: 'Dispensary'
  /** Expiration date of the dispensary if superseded by another */
  expiration?: Maybe<Scalars['Date']>
  id: Scalars['ID']
  /** Dispensary name */
  name: Scalars['String']
  /** Partner code for the dispensary's practitioner */
  practitionerCode: Scalars['String']
  /** URL slug for the dispensary */
  slug: Scalars['String']
  /** Main dispensary that supersedes the current one (if any) */
  supersededBy?: Maybe<Dispensary>
}

export type DispensaryConnection = {
  __typename?: 'DispensaryConnection'
  /** A list of edges. */
  edges: Array<DispensaryEdge>
  /** A list of nodes. */
  nodes: Array<Dispensary>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type DispensaryEdge = {
  __typename?: 'DispensaryEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: Dispensary
}

export type DispensarySuggestions = {
  __typename?: 'DispensarySuggestions'
  suggestedDispensaries: Array<Dispensary>
  /** Zip code used as a point of reference for suggestions */
  zipCode?: Maybe<Scalars['String']>
}

export type DocumentDescription = {
  __typename?: 'DocumentDescription'
  html?: Maybe<Scalars['String']>
  text?: Maybe<Scalars['String']>
}

export type EScript = Node & {
  __typename?: 'EScript'
  /** The date and time the eScript was created. */
  createdAt: Scalars['DateTimeMillis']
  /** The description of the eScript. */
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** The name of the eScript. */
  name: Scalars['String']
  /** The products in the eScript. */
  products: Array<EScriptProduct>
  /** The public promo code that is used by a customer to get the discount. */
  promoCode?: Maybe<Scalars['String']>
  /** The date and time the eScript was last updated. */
  updatedAt: Scalars['DateTimeMillis']
}

/** The connection type for EScript. */
export type EScriptConnection = {
  __typename?: 'EScriptConnection'
  /** A list of edges. */
  edges: Array<EScriptEdge>
  /** A list of nodes. */
  nodes: Array<EScript>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type EScriptEdge = {
  __typename?: 'EScriptEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: EScript
}

/** Properties by which eScripts can be ordered */
export const EScriptOrderField = {
  /** Order by created date-time */
  CreatedAt: 'CREATED_AT',
  /** Order by updated date-time */
  UpdatedAt: 'UPDATED_AT',
} as const

export type EScriptOrderField = (typeof EScriptOrderField)[keyof typeof EScriptOrderField]
/** Options for sorting list of eScripts */
export type EScriptOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** Order by field */
  field: EScriptOrderField
}

export type EScriptProduct = {
  __typename?: 'EScriptProduct'
  /** Whether the product is a single order or auto ship with the given interval. */
  autoShip?: Maybe<AutoShipOption>
  /** Product details. */
  product?: Maybe<Product>
  /** The quantity of the product. */
  quantity: Scalars['Int']
  /** The sku of the product. */
  sku: Scalars['String']
  /** The tags of the product, including the name of the protocols it was added from. */
  tags?: Maybe<Array<Scalars['String']>>
}

export type ExactParentOrChildSkuInput = {
  /** @deprecated(reason: "Unused") */
  limit?: InputMaybe<Scalars['Int']>
  sku?: InputMaybe<Array<Scalars['String']>>
}

export type ExactParentOrChildSkuResults = {
  __typename?: 'ExactParentOrChildSkuResults'
  /** @deprecated Unused */
  limit?: Maybe<Scalars['Int']>
  query: Scalars['String']
  results: Array<IndexedProduct>
  suggestions: Array<Scalars['String']>
  totalCount: Scalars['Int']
}

export type FacetedInput = {
  filters?: InputMaybe<FacetedInputFilters>
  keywords?: InputMaybe<Scalars['String']>
  pagination?: InputMaybe<FacetedInputPagination>
  sort?: InputMaybe<FacetedInputSort>
}

export type FacetedInputFilters = {
  ailment?: InputMaybe<Array<Scalars['ID']>>
  category?: InputMaybe<Array<Scalars['ID']>>
  ingredient?: InputMaybe<Array<Scalars['ID']>>
  labelStatus?: InputMaybe<Array<Scalars['ID']>>
  nameRange?: InputMaybe<Array<Scalars['ID']>>
  productForm?: InputMaybe<Array<Scalars['ID']>>
  specialty?: InputMaybe<Array<Scalars['ID']>>
}

export type FacetedInputPagination = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type FacetedInputSort = {
  name?: InputMaybe<FacetedSortOrder>
}

export type FacetedResults = {
  __typename?: 'FacetedResults'
  aggregations: FacetedResultsAggregations
  keywords?: Maybe<Scalars['String']>
  meta: FacetedResultsMeta
  results: Array<IndexedProduct>
  suggestions: Array<Scalars['String']>
}

export type FacetedResultsAggregation = {
  __typename?: 'FacetedResultsAggregation'
  id: Scalars['String']
  label?: Maybe<Scalars['String']>
  options: Array<FacetedResultsAggregationOption>
}

export type FacetedResultsAggregationOption = {
  __typename?: 'FacetedResultsAggregationOption'
  count?: Maybe<Scalars['Int']>
  label?: Maybe<Scalars['String']>
  value: Scalars['ID']
}

export type FacetedResultsAggregations = {
  __typename?: 'FacetedResultsAggregations'
  ailment?: Maybe<FacetedResultsAggregation>
  category?: Maybe<FacetedResultsAggregation>
  ingredient?: Maybe<FacetedResultsAggregation>
  labelStatus?: Maybe<FacetedResultsAggregation>
  nameRange?: Maybe<FacetedResultsAggregation>
  productForm?: Maybe<FacetedResultsAggregation>
  specialty?: Maybe<FacetedResultsAggregation>
}

export type FacetedResultsMeta = {
  __typename?: 'FacetedResultsMeta'
  count: FacetedResultsMetaCount
  pagination: FacetedResultsMetaPagination
}

export type FacetedResultsMetaCount = {
  __typename?: 'FacetedResultsMetaCount'
  /** Total number of results */
  all: Scalars['Int']
  /** Number of results in current response */
  current: Scalars['Int']
}

export type FacetedResultsMetaPagination = {
  __typename?: 'FacetedResultsMetaPagination'
  currentPage: Scalars['Int']
  pageSize: Scalars['Int']
  totalPages: Scalars['Int']
}

export const FacetedSortOrder = {
  Asc: 'asc',
  Desc: 'desc',
} as const

export type FacetedSortOrder = (typeof FacetedSortOrder)[keyof typeof FacetedSortOrder]
/** Filter options for a particular facet/aggregation */
export type Filter = {
  __typename?: 'Filter'
  /** The filter identifier */
  id: Scalars['String']
  /** The filter options */
  options: Array<FilterValue>
}

/** Single filter option (similar to an aggregation bucket) */
export type FilterValue = {
  __typename?: 'FilterValue'
  /** The number of results matching the filter value */
  count: Scalars['Int']
  /** The filter option name/value. Supply this value to filter the results */
  value: Scalars['String']
}

/** CyberSource Flex v2 capture context */
export type FlexCaptureContext = {
  __typename?: 'FlexCaptureContext'
  token: Scalars['String']
}

/** Rich text presented as HTML or plain text. */
export type HtmlOrText = {
  __typename?: 'HtmlOrText'
  html?: Maybe<Scalars['String']>
  text?: Maybe<Scalars['String']>
}

export type IndexedDocument = {
  id: Scalars['String']
  name: Scalars['String']
}

export type IndexedProduct = IndexedDocument & {
  __typename?: 'IndexedProduct'
  advisorTags: Array<Scalars['String']>
  ailments: Array<Scalars['String']>
  description: DocumentDescription
  id: Scalars['String']
  ingredients: Array<Scalars['String']>
  /** Maximum label status of child products */
  labelStatus?: Maybe<ProductLabelStatus>
  name: Scalars['String']
  priceRange?: Maybe<MoneyRange>
  retailPriceRange?: Maybe<MoneyRange>
  sanityImageJson?: Maybe<Scalars['String']>
  sanityImageUrl?: Maybe<Scalars['String']>
  shortDescription: DocumentDescription
  shortDescriptionV2?: Maybe<Scalars['String']>
  sku: Scalars['String']
  stockStatus?: Maybe<IndexedProductStockStatus>
  tagline?: Maybe<Scalars['String']>
  /** @deprecated Use `name` */
  title: Scalars['String']
  urlKey: Scalars['String']
  variants?: Maybe<IndexedProductVariants>
}

export const IndexedProductStockStatus = {
  InStock: 'inStock',
  OutOfStock: 'outOfStock',
} as const

export type IndexedProductStockStatus =
  (typeof IndexedProductStockStatus)[keyof typeof IndexedProductStockStatus]
export const IndexedProductVariantAttribute = {
  Dosage: 'dosage',
  Flavor: 'flavor',
  FlavorSize: 'flavorSize',
  Size: 'size',
} as const

export type IndexedProductVariantAttribute =
  (typeof IndexedProductVariantAttribute)[keyof typeof IndexedProductVariantAttribute]
export type IndexedProductVariants = {
  __typename?: 'IndexedProductVariants'
  summary: IndexedProductVariantsSummary
}

export type IndexedProductVariantsSummary = {
  __typename?: 'IndexedProductVariantsSummary'
  attributes: Array<IndexedProductVariantAttribute>
  values: IndexedProductVariantsSummaryValues
}

export type IndexedProductVariantsSummaryValues = {
  __typename?: 'IndexedProductVariantsSummaryValues'
  dosage?: Maybe<Array<Scalars['String']>>
  flavor?: Maybe<Array<Scalars['String']>>
  flavorSize?: Maybe<Array<Scalars['String']>>
  size?: Maybe<Array<Scalars['String']>>
}

export type Invoice = Node & {
  __typename?: 'Invoice'
  id: Scalars['ID']
  transactionNumber: Scalars['String']
}

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection'
  edges: Array<InvoiceEdge>
  nodes: Array<Invoice>
  pageInfo: PageInfo
}

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge'
  cursor: Scalars['String']
  node: Invoice
}

export type LibraryResource = {
  __typename?: 'LibraryResource'
  /** Library category name, e.g. "Price List" */
  category: Scalars['String']
  /** Library category slug, e.g. "price-list" */
  categorySlug: Scalars['String']
  excludeFromSearch: Scalars['Boolean']
  id: Scalars['ID']
  shortDescription?: Maybe<Scalars['String']>
  slug: Scalars['String']
  /** Thumbnail image for the library resource */
  thumbnailImage?: Maybe<SanityImage>
  title: Scalars['String']
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type LibraryResourceConnection = {
  __typename?: 'LibraryResourceConnection'
  /** A list of edges. */
  edges: Array<LibraryResourceEdge>
  /** A list of nodes. */
  nodes: Array<LibraryResource>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type LibraryResourceEdge = {
  __typename?: 'LibraryResourceEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: LibraryResource
}

/** Narrow the library resource results by filtering on specific fields */
export type LibraryResourceFilter = {
  /** Category value */
  category?: InputMaybe<Scalars['String']>
}

/** Filters related library resource results */
export type LibraryResourceFilters = {
  __typename?: 'LibraryResourceFilters'
  /** Categories found in library resource results */
  category: Filter
}

/** Properties by which library resources can be ordered */
export const LibraryResourceOrderField = {
  /** Order by category */
  Category: 'CATEGORY',
  /** Order by score/relevance */
  Score: 'SCORE',
  /** Order by title */
  Title: 'TITLE',
} as const

export type LibraryResourceOrderField =
  (typeof LibraryResourceOrderField)[keyof typeof LibraryResourceOrderField]
/** Options for sorting list of library resources */
export type LibraryResourceOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** "Order by" field */
  field: LibraryResourceOrderField
}

export type MailingAddress = {
  __typename?: 'MailingAddress'
  addressee?: Maybe<Scalars['String']>
  attention?: Maybe<Scalars['String']>
  city: Scalars['String']
  country: Scalars['String']
  countryCode: Scalars['String']
  phone?: Maybe<Scalars['String']>
  state: Scalars['String']
  street: Array<Scalars['String']>
  zip: Scalars['String']
}

export type Money = {
  __typename?: 'Money'
  /** Decimal money amount. */
  amount: Scalars['Decimal']
  /** Currency of the money. */
  currencyCode: CurrencyCode
}

export type MoneyRange = {
  __typename?: 'MoneyRange'
  /** Currency of the money range. */
  currencyCode: CurrencyCode
  /** The highest price in the range. */
  maximum: Scalars['Decimal']
  /** The lowest price in the range. */
  minimum: Scalars['Decimal']
}

/** Merged Mutation object */
export type Mutation = {
  __typename?: 'Mutation'
  /** Create a new eScript. */
  createEScript?: Maybe<EScript>
  /** Create capture context for payment information */
  createFlexCaptureContext: FlexCaptureContext
  /** Create permanent token from captured card details */
  createPaymentInstrument: Scalars['String']
  /** Delete the account document for the customer. */
  deleteAccountDocument?: Maybe<DeleteAccountDocumentPayload>
  /** Delete eScript with the given id. */
  deleteEScript?: Maybe<DeleteEScriptPayload>
  /** Delete the payout method for the customer. */
  deletePayoutMethod?: Maybe<DeletePayoutMethodPayload>
  /** Request commissions payout for the customer. */
  requestCommissionsPayout?: Maybe<CommissionsPayout>
  requestCustomPacketOrder: CustomPacketOrderRequest
  requestOnboard: OnboardRequest
  /** Request rebates payout for the customer. */
  requestRebatesPayout?: Maybe<RebatesPayout>
  /** Select a dispensary (for a patient) */
  selectDispensary: Dispensary
  /** Suggest a list of dispensaries (for a patient) */
  suggestDispensaries: DispensarySuggestions
  /** Update eScript with the given id. */
  updateEScript?: Maybe<EScript>
  /** Update the payout method for the customer. */
  updatePayoutMethodAch?: Maybe<PayoutMethodAch>
  /** Upload a document for the customer account. */
  uploadAccountDocument?: Maybe<AccountDocument>
}

/** Merged Mutation object */
export type MutationCreateEScriptArgs = {
  input: CreateEScriptInput
}

/** Merged Mutation object */
export type MutationCreatePaymentInstrumentArgs = {
  captured: Scalars['String']
  referenceCode: Scalars['String']
}

/** Merged Mutation object */
export type MutationDeleteAccountDocumentArgs = {
  documentType: AccountDocumentType
}

/** Merged Mutation object */
export type MutationDeleteEScriptArgs = {
  id: Scalars['ID']
}

/** Merged Mutation object */
export type MutationRequestCommissionsPayoutArgs = {
  input?: InputMaybe<RewardsPayoutInput>
}

/** Merged Mutation object */
export type MutationRequestCustomPacketOrderArgs = {
  input: RequestCustomPacketOrderInput
}

/** Merged Mutation object */
export type MutationRequestOnboardArgs = {
  input: OnboardRequestInput
  wait?: Scalars['Boolean']
}

/** Merged Mutation object */
export type MutationRequestRebatesPayoutArgs = {
  input?: InputMaybe<RewardsPayoutInput>
}

/** Merged Mutation object */
export type MutationSelectDispensaryArgs = {
  id: Scalars['ID']
  isWorkingWithPractitioner: Scalars['Boolean']
  method: SelectDispensaryMethod
  siteArea: SelectDispensarySiteArea
}

/** Merged Mutation object */
export type MutationSuggestDispensariesArgs = {
  reroll?: Scalars['Boolean']
  zipCode: Scalars['String']
}

/** Merged Mutation object */
export type MutationUpdateEScriptArgs = {
  input: UpdateEScriptInput
}

/** Merged Mutation object */
export type MutationUpdatePayoutMethodAchArgs = {
  input: UpdatePayoutMethodAchInput
}

/** Merged Mutation object */
export type MutationUploadAccountDocumentArgs = {
  input: UploadAccountDocumentInput
}

export type NewEScriptProduct = {
  /** No autoShip means single order. */
  autoShip?: InputMaybe<AutoShipOption>
  /** Quantity should be greater than 0. */
  quantity: Scalars['Int']
  /** Sku should be unique within an eScript. */
  sku: Scalars['String']
  /** No tags means remove existing when updating. */
  tags?: InputMaybe<Array<Scalars['String']>>
}

export type Node = {
  id: Scalars['ID']
}

export type OnboardRequest = {
  __typename?: 'OnboardRequest'
  /** New user's first name */
  firstName: Scalars['String']
  /** Response from NetSuite RESTlet */
  response?: Maybe<Scalars['String']>
  /** Current status of the new user's onboard request */
  status: OnboardRequestStatus
  /** When the onboard request was submitted */
  submittedAt: Scalars['DateTimeMillis']
  /** When the onboard request was last updated */
  updatedAt: Scalars['DateTimeMillis']
}

/** Address input for onboard requests */
export type OnboardRequestAddressInput = {
  /** City */
  city: Scalars['String']
  /** Two letter code for country (e.g. "US", "CA") */
  countryCode: Scalars['String']
  /** State or province */
  state: Scalars['String']
  /** Street address */
  street: Array<Scalars['String']>
  /** Postal code */
  zip: Scalars['String']
}

export type OnboardRequestInput = {
  /** Input for a patient/consumer */
  patient?: InputMaybe<PatientOnboardRequestInput>
  /** Input for a practitioner */
  practitioner?: InputMaybe<PractitionerOnboardRequestInput>
  /** Input for a student */
  student?: InputMaybe<StudentOnboardRequestInput>
}

export const OnboardRequestStatus = {
  /** Request has completed successfully */
  Completed: 'COMPLETED',
  /** Request has failed */
  Failed: 'FAILED',
  /** Request is pending/in-progress */
  InProgress: 'IN_PROGRESS',
} as const

export type OnboardRequestStatus = (typeof OnboardRequestStatus)[keyof typeof OnboardRequestStatus]
export type Order = Node & {
  __typename?: 'Order'
  coloradoRetailDeliveryFee?: Maybe<Money>
  date: Scalars['Date']
  discountTotal: Money
  fulfillments: Array<OrderFulfillment>
  holdUntilMonday: Scalars['Boolean']
  id: Scalars['ID']
  invoices: InvoiceConnection
  lines: Array<OrderLine>
  payment: OrderPayment
  promoCodes: Array<Scalars['String']>
  salesTax: Money
  shippingAddress?: Maybe<MailingAddress>
  shippingMethod: Scalars['String']
  shippingTotal: Money
  status: Scalars['String']
  subtotal: Money
  total: Money
  transactionNumber: Scalars['String']
}

export type OrderInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type OrderConnection = {
  __typename?: 'OrderConnection'
  edges: Array<OrderEdge>
  nodes: Array<Order>
  pageInfo: PageInfo
}

/** Possible directions in which to order a list of items */
export const OrderDirection = {
  /** Ascending */
  Asc: 'ASC',
  /** Descending */
  Desc: 'DESC',
} as const

export type OrderDirection = (typeof OrderDirection)[keyof typeof OrderDirection]
export type OrderEdge = {
  __typename?: 'OrderEdge'
  cursor: Scalars['String']
  node: Order
}

export type OrderFulfillment = {
  __typename?: 'OrderFulfillment'
  date: Scalars['Date']
  lines: Array<OrderFulfillmentLine>
  shippingMethod: Scalars['String']
  status: Scalars['String']
  trackingLink?: Maybe<Scalars['String']>
  trackingNumber?: Maybe<Scalars['String']>
  warehouseLocation: Scalars['String']
}

export type OrderFulfillmentLine = {
  __typename?: 'OrderFulfillmentLine'
  product?: Maybe<Product>
  quantity: Scalars['Int']
  sku: Scalars['String']
}

export type OrderLine = {
  __typename?: 'OrderLine'
  discount: Money
  net: Money
  product?: Maybe<Product>
  quantity?: Maybe<Scalars['Int']>
  quantityBackordered?: Maybe<Scalars['Int']>
  quantityInvoiced?: Maybe<Scalars['Int']>
  quantityShipped?: Maybe<Scalars['Int']>
  rate?: Maybe<Money>
  sku: Scalars['String']
}

export type OrderPayment = {
  __typename?: 'OrderPayment'
  card?: Maybe<OrderPaymentCard>
  terms?: Maybe<Scalars['String']>
}

export type OrderPaymentCard = {
  __typename?: 'OrderPaymentCard'
  issuer?: Maybe<PaymentCardIssuer>
  lastFour?: Maybe<Scalars['String']>
  wallet?: Maybe<DigitalWallet>
}

export type Page = {
  __typename?: 'Page'
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  slug: Scalars['String']
  title: Scalars['String']
}

export type PageConnection = {
  __typename?: 'PageConnection'
  /** A list of edges. */
  edges: Array<PageEdge>
  /** A list of nodes. */
  nodes: Array<Page>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: Page
}

/** Information about pagination in a connection */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>
}

/** Properties by which page can be ordered */
export const PageOrderField = {
  /** Order by score/relevance */
  Score: 'SCORE',
  /** Order by title */
  Title: 'TITLE',
} as const

export type PageOrderField = (typeof PageOrderField)[keyof typeof PageOrderField]
/** Options for sorting list of page */
export type PageOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** "Order by" field */
  field: PageOrderField
}

export type ParentProduct = {
  __typename?: 'ParentProduct'
  advisorTags: Array<Scalars['String']>
  ailments: Array<Scalars['String']>
  /** Categories to which this product belongs */
  categories: Array<Scalars['String']>
  /** Extended product description */
  description: HtmlOrText
  id: Scalars['ID']
  ingredients: Array<Scalars['String']>
  /** Primary image for the product */
  mainImage?: Maybe<SanityImage>
  name: Scalars['String']
  /** Name range (e.g. "A-C") */
  nameRange?: Maybe<Scalars['String']>
  priceRange: MoneyRange
  /** Product form (e.g. "Capsule") */
  productForm?: Maybe<Scalars['String']>
  /** Products grouped under this parent product */
  products: ProductConnection
  retailPriceRange: MoneyRange
  /** Product description */
  shortDescription: HtmlOrText
  /** Short description/abstract */
  shortDescriptionV2?: Maybe<Scalars['String']>
  sku: Scalars['String']
  specialties: Array<Scalars['String']>
  tagline?: Maybe<Scalars['String']>
  urlKey: Scalars['String']
  /** Available product variant attributes */
  variantAttributes: Array<ProductVariantAttributeValues>
}

export type ParentProductCategoriesArgs = {
  filter?: Array<Scalars['String']>
}

export type ParentProductProductsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<ProductOrdering>>
}

export type ParentProductConnection = {
  __typename?: 'ParentProductConnection'
  /** A list of edges. */
  edges: Array<ParentProductEdge>
  /** A list of nodes. */
  nodes: Array<ParentProduct>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ParentProductEdge = {
  __typename?: 'ParentProductEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: ParentProduct
}

/** Narrow the parent product results by filtering on specific fields */
export type ParentProductFilter = {
  /** Ailment value or empty string to exclude all */
  ailment?: InputMaybe<Scalars['String']>
  /** A product category value or empty string to exclude all */
  category?: InputMaybe<Scalars['String']>
  /** Ingredient value or empty string to exclude all */
  ingredient?: InputMaybe<Scalars['String']>
  /** Label status value */
  labelStatus?: InputMaybe<Scalars['String']>
  /** Name range value or empty string to exclude all */
  nameRange?: InputMaybe<Scalars['String']>
  /** Product form value or empty string to exclude all */
  productForm?: InputMaybe<Scalars['String']>
  /** Specialty value or empty string to exclude all */
  specialty?: InputMaybe<Scalars['String']>
}

/** Filters related to parent product results */
export type ParentProductFilters = {
  __typename?: 'ParentProductFilters'
  /** Ailments found in parent product results */
  ailment: Filter
  /** Categories found in parent product results */
  category: Filter
  /** Ingredients found in parent product results */
  ingredient: Filter
  /** Label status values found in parent product results */
  labelStatus: Filter
  /** Name ranges found in parent product results */
  nameRange: Filter
  /** Product form values found in parent product results */
  productForm: Filter
  /** Specialties found in parent product results */
  specialty: Filter
}

/** Filters related to parent product results */
export type ParentProductFiltersLabelStatusArgs = {
  labelName: Scalars['String']
}

/** Properties by which parent products can be ordered */
export const ParentProductOrderField = {
  /** Order by label status (maximum status of child products) */
  LabelStatus: 'LABEL_STATUS',
  /** Order by name */
  Name: 'NAME',
  /** Order by score/relevance */
  Score: 'SCORE',
} as const

export type ParentProductOrderField =
  (typeof ParentProductOrderField)[keyof typeof ParentProductOrderField]
/** Options for sorting list of parent products */
export type ParentProductOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** "Order by" field */
  field: ParentProductOrderField
}

/** Onboard request input for a patient/consumer */
export type PatientOnboardRequestInput = {
  /** New user's first name */
  firstName: Scalars['String']
  /** New user's last name */
  lastName: Scalars['String']
  /** New user's phone number */
  phone: Scalars['String']
  /** New user's practitioner code if registering from a dispensary */
  practitionerCode?: InputMaybe<Scalars['String']>
  /** New user's account subtype/variant */
  subtype: PatientOnboardRequestSubtype
}

/** Account subtype for a patient onboard request */
export const PatientOnboardRequestSubtype = {
  Patient: 'PATIENT',
  Visitor: 'VISITOR',
} as const

export type PatientOnboardRequestSubtype =
  (typeof PatientOnboardRequestSubtype)[keyof typeof PatientOnboardRequestSubtype]
export const PaymentCardIssuer = {
  AmericanExpress: 'AMERICAN_EXPRESS',
  Discover: 'DISCOVER',
  Mastercard: 'MASTERCARD',
  Paypal: 'PAYPAL',
  Visa: 'VISA',
} as const

export type PaymentCardIssuer = (typeof PaymentCardIssuer)[keyof typeof PaymentCardIssuer]
export type PayoutMethod = {
  /** The date and time the payout method was last updated. */
  updatedAt: Scalars['DateTimeMillis']
}

export type PayoutMethodAch = PayoutMethod & {
  __typename?: 'PayoutMethodAch'
  /** The name of the account holder. */
  accountHolderName: Scalars['String']
  /** Last 4 digits of the account number. */
  accountNumber: Scalars['String']
  /** The type of account. */
  accountType: AccountType
  /** The name of the bank. */
  bankName: Scalars['String']
  /** The routing number of the bank. */
  routingNumber: Scalars['String']
  /** The date and time the payout method was last updated. */
  updatedAt: Scalars['DateTimeMillis']
}

/** Onboard request input for a practitioner */
export type PractitionerOnboardRequestInput = {
  /** Address from which the practitioner operates */
  address: OnboardRequestAddressInput
  /** URL of an Uploaded certificate */
  certificateUrl?: InputMaybe<Scalars['String']>
  /** New user's first name */
  firstName: Scalars['String']
  /** New user's last name */
  lastName: Scalars['String']
  /** License number under which the practitioner operates */
  licenseNumber?: InputMaybe<Scalars['String']>
  /** Practice's phone number */
  phone: Scalars['String']
  /** Practitioner's practice/company name */
  practiceName: Scalars['String']
  /** Type of practice operated by the practitioner */
  practiceType: Scalars['String']
  /** Brand with which the practitioner should be associated (e.g. DFH, DFB) */
  primaryBrand?: InputMaybe<Scalars['String']>
  /** Marketing campaign to attribute for new user referral */
  referralCode?: InputMaybe<Scalars['String']>
  /** Practitioner's specialty */
  specialty: Scalars['String']
}

/** Aggregations/facets for grouped predictive search results */
export type PredictiveSearchAggregations = {
  __typename?: 'PredictiveSearchAggregations'
  parentProductCategories: Array<BucketValue>
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResult = {
  __typename?: 'PredictiveSearchResult'
  aggregations: PredictiveSearchAggregations
  libraryResources: Array<LibraryResource>
  pages: Array<Page>
  parentProducts: Array<ParentProduct>
  products: Array<Product>
  searchTerms: Array<Scalars['String']>
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResultLibraryResourcesArgs = {
  limit: Scalars['Int']
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResultPagesArgs = {
  limit: Scalars['Int']
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResultParentProductsArgs = {
  limit: Scalars['Int']
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResultProductsArgs = {
  limit: Scalars['Int']
}

/** Search results for a given query, grouped by type */
export type PredictiveSearchResultSearchTermsArgs = {
  limit: Scalars['Int']
}

/** Product (or variant) - a distinct item for sale. */
export type Product = {
  __typename?: 'Product'
  advisorTags: Array<Scalars['String']>
  id: Scalars['ID']
  /** Get label status for this product */
  labelStatus: ProductLabelStatus
  /** Primary image for the product */
  mainImage?: Maybe<SanityImage>
  name: Scalars['String']
  /** Get parent product for this product */
  parentProduct: ParentProduct
  /** Get price for this product */
  price: Money
  /** Get retail price for this product */
  retailPrice: Money
  sku: Scalars['String']
  /** Attributes which distinguish this product from other products within the same parent product */
  variantAttributes: Array<ProductVariantAttributeValue>
}

/** Product (or variant) - a distinct item for sale. */
export type ProductLabelStatusArgs = {
  labelName: Scalars['String']
}

export type ProductConnection = {
  __typename?: 'ProductConnection'
  /** A list of edges. */
  edges: Array<ProductEdge>
  /** A list of nodes. */
  nodes: Array<Product>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: Product
}

/** Label status for a given product */
export const ProductLabelStatus = {
  /** No label */
  Absent: 'ABSENT',
  /** Label present */
  Present: 'PRESENT',
} as const

export type ProductLabelStatus = (typeof ProductLabelStatus)[keyof typeof ProductLabelStatus]
/** Properties by which products can be ordered */
export const ProductOrderField = {
  /** Order by name */
  Name: 'NAME',
  /** Order by SKU */
  Sku: 'SKU',
} as const

export type ProductOrderField = (typeof ProductOrderField)[keyof typeof ProductOrderField]
/** Options for sorting list of products */
export type ProductOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** "Order by" field */
  field: ProductOrderField
}

/** Product variant attributes */
export const ProductVariantAttribute = {
  Dosage: 'DOSAGE',
  Flavor: 'FLAVOR',
  FlavorSize: 'FLAVOR_SIZE',
  Size: 'SIZE',
} as const

export type ProductVariantAttribute =
  (typeof ProductVariantAttribute)[keyof typeof ProductVariantAttribute]
/** Product variant attribute value */
export type ProductVariantAttributeValue = {
  __typename?: 'ProductVariantAttributeValue'
  attribute: ProductVariantAttribute
  value: Scalars['String']
}

/** Values for a product variant attribute (e.g. size) */
export type ProductVariantAttributeValues = {
  __typename?: 'ProductVariantAttributeValues'
  attribute: ProductVariantAttribute
  values: Array<Scalars['String']>
}

/** Merged Query object */
export type Query = {
  __typename?: 'Query'
  autoComplete: AutoCompleteResults
  /** Determine checkout actions available for a cart */
  availableCheckoutActions: Array<Scalars['String']>
  /** Get customer account for the current access token. */
  customer?: Maybe<Customer>
  /** Get dispensaries for a practitioner code */
  dispensariesByCode: DispensaryConnection
  /** Get a dispensary by ID */
  dispensary?: Maybe<Dispensary>
  /** Get the first dispensary for a practitioner code */
  dispensaryByCode?: Maybe<Dispensary>
  /** Get a dispensary by slug */
  dispensaryBySlug?: Maybe<Dispensary>
  /** Get an eScript by ID. */
  eScript?: Maybe<EScript>
  /** A list of eScripts created by the user. */
  eScripts?: Maybe<EScriptConnection>
  exact: ExactParentOrChildSkuResults
  faceted: FacetedResults
  /** Get a library resource by ID */
  libraryResource?: Maybe<LibraryResource>
  /** Get a library resource by slug */
  libraryResourceBySlug?: Maybe<LibraryResource>
  /** Get a list of library resources */
  libraryResources: LibraryResourceConnection
  onboardRequest?: Maybe<OnboardRequest>
  /** Get a page by ID */
  page?: Maybe<Page>
  /** Get a list of pages */
  pages: PageConnection
  /** Get a parent product by ID */
  parentProduct?: Maybe<ParentProduct>
  /** Get a parent product by SKU */
  parentProductBySku?: Maybe<ParentProduct>
  /** Get a list of parent products */
  parentProducts: ParentProductConnection
  /** Predictive search for items */
  predictiveSearch: PredictiveSearchResult
  /** Get a product by ID */
  product?: Maybe<Product>
  /** Get a product by SKU */
  productBySku?: Maybe<Product>
  /** Get a list of products */
  products: ProductConnection
  /** Search for products, library resources, pages, and more */
  search: SearchResultItemConnection
}

/** Merged Query object */
export type QueryAutoCompleteArgs = {
  enableFullCatalog?: InputMaybe<Scalars['Boolean']>
  input?: InputMaybe<AutoCompleteInput>
  limit?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
}

/** Merged Query object */
export type QueryAvailableCheckoutActionsArgs = {
  id: Scalars['String']
}

/** Merged Query object */
export type QueryDispensariesByCodeArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  code: Scalars['String']
  first?: InputMaybe<Scalars['Int']>
  includeSuperseded?: Scalars['Boolean']
  last?: InputMaybe<Scalars['Int']>
}

/** Merged Query object */
export type QueryDispensaryArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryDispensaryByCodeArgs = {
  code: Scalars['String']
}

/** Merged Query object */
export type QueryDispensaryBySlugArgs = {
  slug: Scalars['String']
}

/** Merged Query object */
export type QueryEScriptArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryEScriptsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<EScriptOrdering>>
  query?: InputMaybe<Scalars['String']>
}

/** Merged Query object */
export type QueryExactArgs = {
  enableFullCatalog?: InputMaybe<Scalars['Boolean']>
  input?: InputMaybe<ExactParentOrChildSkuInput>
  sku?: InputMaybe<Array<Scalars['String']>>
}

/** Merged Query object */
export type QueryFacetedArgs = {
  enableFullCatalog?: InputMaybe<Scalars['Boolean']>
  filters?: InputMaybe<FacetedInputFilters>
  input?: InputMaybe<FacetedInput>
  keywords?: InputMaybe<Scalars['String']>
  orderBy?: InputMaybe<Array<ParentProductOrdering>>
  pagination?: InputMaybe<FacetedInputPagination>
}

/** Merged Query object */
export type QueryLibraryResourceArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryLibraryResourceBySlugArgs = {
  slug: Scalars['String']
}

/** Merged Query object */
export type QueryLibraryResourcesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LibraryResourceOrdering>>
  query?: InputMaybe<Scalars['String']>
}

/** Merged Query object */
export type QueryPageArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PageOrdering>>
  query?: InputMaybe<Scalars['String']>
}

/** Merged Query object */
export type QueryParentProductArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryParentProductBySkuArgs = {
  sku: Scalars['String']
}

/** Merged Query object */
export type QueryParentProductsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  labelName?: InputMaybe<Scalars['String']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<ParentProductOrdering>>
  query?: InputMaybe<Scalars['String']>
  skus?: InputMaybe<Array<Scalars['String']>>
}

/** Merged Query object */
export type QueryPredictiveSearchArgs = {
  query: Scalars['String']
}

/** Merged Query object */
export type QueryProductArgs = {
  id: Scalars['ID']
}

/** Merged Query object */
export type QueryProductBySkuArgs = {
  sku: Scalars['String']
}

/** Merged Query object */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<ProductOrdering>>
  skus?: InputMaybe<Array<Scalars['String']>>
}

/** Merged Query object */
export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  libraryResourceFilters?: InputMaybe<Array<LibraryResourceFilter>>
  orderBy?: InputMaybe<Array<SearchOrdering>>
  parentProductFilters?: InputMaybe<Array<ParentProductFilter>>
  query?: InputMaybe<Scalars['String']>
  types?: InputMaybe<Array<SearchType>>
}

export type RebatesPayout = {
  __typename?: 'RebatesPayout'
  success: Scalars['Boolean']
}

export type RequestCustomPacketOrderInput = {
  /** Brand name to use on packets */
  brandName: Scalars['String']
  /** Contact email for order */
  contactEmail: Scalars['String']
  /** Kit name to use for the order */
  kitName: Scalars['String']
  /** Order currency code (e.g. "USD") */
  orderCurrencyCode: CurrencyCode
  /** Packaging fee per box */
  packagingFeePerBox: Scalars['Decimal']
  /** Packet configurations */
  packets: CustomPacketOrderPacketsInput
  /** Number of packets each box should contain */
  packetsPerBox: Scalars['Int']
  /** Number of boxes requested */
  quantity: Scalars['Int']
  /** Time preference for the order (e.g. "daily", "am/pm") */
  timePreference: Scalars['String']
}

/** The amounts for each rewards classification */
export type RewardsClassificationAmounts = {
  __typename?: 'RewardsClassificationAmounts'
  dfhWebStore: Money
  eStore: Money
  inPractice: Money
  retail: Money
  total: Money
  wellWorld: Money
  wholesale: Money
}

/** The rewards levels available. */
export const RewardsLevel = {
  Level_1: 'LEVEL_1',
  Level_2: 'LEVEL_2',
  Level_3: 'LEVEL_3',
  Level_4: 'LEVEL_4',
  Level_5: 'LEVEL_5',
  Level_6: 'LEVEL_6',
} as const

export type RewardsLevel = (typeof RewardsLevel)[keyof typeof RewardsLevel]
export type RewardsOrderCounts = {
  __typename?: 'RewardsOrderCounts'
  retail: Scalars['Int']
  total: Scalars['Int']
  wholesale: Scalars['Int']
}

export type RewardsPayoutInput = {
  /** Amount of rewards to consume. */
  consumeAmountMax?: InputMaybe<Scalars['Decimal']>
}

/** The amounts for each retail rewards classification */
export type RewardsRetailClassificationAmounts = {
  __typename?: 'RewardsRetailClassificationAmounts'
  dfhWebStore: Money
  eStore: Money
  total: Money
  wellWorld: Money
}

/** The rewards snapshot for a specific period. */
export type RewardsSnapshot = Node & {
  __typename?: 'RewardsSnapshot'
  commissionsEarned: RewardsRetailClassificationAmounts
  commissionsQualifyingSales: RewardsRetailClassificationAmounts
  commissionsStatus: RewardsStatus
  id: Scalars['ID']
  level: RewardsLevel
  /** @deprecated Use orderCounts.total instead. This field will be removed in the future. */
  orderCount: Scalars['Int']
  orderCounts: RewardsOrderCounts
  period: Scalars['RewardsPeriod']
  rebateEarned: RewardsClassificationAmounts
  rebateQualifyingSales: RewardsClassificationAmounts
  rebateStatus: RewardsStatus
  /** @deprecated Use rebateEarned instead. This field will be removed in the future. */
  rebatesEarned: RewardsClassificationAmounts
  /** @deprecated Use tierQualifyingSales instead. */
  sales: RewardsClassificationAmounts
  tierQualifyingSales: RewardsClassificationAmounts
  totalEarned: RewardsTotalAmounts
}

/** The connection type for the rewards snapshots. */
export type RewardsSnapshotConnection = {
  __typename?: 'RewardsSnapshotConnection'
  /** A list of edges. */
  edges: Array<RewardsSnapshotEdge>
  /** A list of nodes. */
  nodes: Array<RewardsSnapshot>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type RewardsSnapshotEdge = {
  __typename?: 'RewardsSnapshotEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: RewardsSnapshot
}

export const RewardsStatus = {
  Applied: 'APPLIED',
  None: 'NONE',
  Pending: 'PENDING',
} as const

export type RewardsStatus = (typeof RewardsStatus)[keyof typeof RewardsStatus]
/** The total rewards amounts that can be extended with classification amounts */
export type RewardsTotalAmounts = {
  __typename?: 'RewardsTotalAmounts'
  total: Money
}

/** A rewards transaction representing a specific transaction or record. */
export type RewardsTransaction = Node & {
  __typename?: 'RewardsTransaction'
  /** The name of the addressee */
  addressee?: Maybe<Scalars['String']>
  /** The classification of the transaction (e.g., wholesale or retail). */
  classification?: Maybe<RewardsTransactionClassification>
  /** The amount of commission earned for this transaction. */
  commissionEarned: Money
  /** The amount of commission qualifying sales for this transaction. */
  commissionQualifyingSum: Money
  /** The date and time the transaction was created. */
  createdAt: Scalars['DateTimeMillis']
  /** The total discount applied to the transaction. */
  discountTotal: Money
  id: Scalars['ID']
  /** The due date for the transaction (e.g., invoice due date). */
  lines: Array<Maybe<RewardsTransactionLine>>
  /** The amount of rebate earned for this transaction. */
  rebateEarned: Money
  /** The amount of rebate qualifying sales for this transaction. */
  rebateQualifyingSum: Money
  /** The sales tax applied to the transaction. */
  salesTax: Money
  /** The shipping cost for this transaction. */
  shippingTotal: Money
  /** Transaction for which the Rewards Transaction was created. */
  sourceTransaction?: Maybe<SourceTransaction>
  /** The subtotal amount before taxes and discounts. */
  subtotal: Money
  /**
   * A list of arbitrary tags associated with this transaction,
   * for filtering or categorization purposes.
   */
  tags: Array<CustomerOrderTag>
  /** The total amount for the transaction after taxes and discounts. */
  total: Money
  /** The date the transaction was created. */
  transactionDate: Scalars['Date']
  /** Displayable transaction number. */
  transactionNumber: Scalars['String']
}

/** Enum for transaction classification. */
export const RewardsTransactionClassification = {
  /** Represents a retail transaction classification. */
  Retail: 'RETAIL',
  /** Represents a wholesale transaction classification. */
  Wholesale: 'WHOLESALE',
} as const

export type RewardsTransactionClassification =
  (typeof RewardsTransactionClassification)[keyof typeof RewardsTransactionClassification]
export type RewardsTransactionConnection = {
  __typename?: 'RewardsTransactionConnection'
  /** A list of edges. */
  edges: Array<RewardsTransactionEdge>
  /** A list of nodes. */
  nodes: Array<RewardsTransaction>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type RewardsTransactionEdge = {
  __typename?: 'RewardsTransactionEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']
  /** The item at the end of the edge. */
  node: RewardsTransaction
}

export type RewardsTransactionLine = {
  __typename?: 'RewardsTransactionLine'
  /** Description of the product/line. */
  memo?: Maybe<Scalars['String']>
  /** The amount of the line item. */
  net: Money
  /** The product associated with the line item. */
  product?: Maybe<Product>
  /** The quantity ordered of the product. */
  quantity?: Maybe<Scalars['Int']>
  /** The rate for each unit of the product. */
  rate?: Maybe<Money>
  /** The sku of the product. */
  sku: Scalars['String']
}

/** Sanity image indexed in Solr */
export type SanityImage = {
  __typename?: 'SanityImage'
  json: Scalars['String']
  url: Scalars['String']
}

/** Filters/aggregations for search results */
export type SearchFilters = {
  __typename?: 'SearchFilters'
  /** Filters for library resource results */
  libraryResource: LibraryResourceFilters
  /** Filters for parent product results */
  parentProduct: ParentProductFilters
}

/** Properties by which results can be ordered */
export const SearchOrderField = {
  /** Order by name or title */
  Name: 'NAME',
  /** Order by score/relevance */
  Score: 'SCORE',
} as const

export type SearchOrderField = (typeof SearchOrderField)[keyof typeof SearchOrderField]
/** Options for sorting list of search results */
export type SearchOrdering = {
  /** Sort direction - default to field's natural direction */
  direction?: InputMaybe<OrderDirection>
  /** "Order by" field */
  field: SearchOrderField
}

/** A product, page, or library resource that matches a search query */
export type SearchResultItem = LibraryResource | Page | ParentProduct | Product

export type SearchResultItemConnection = {
  __typename?: 'SearchResultItemConnection'
  /** A list of edges. */
  edges: Array<SearchResultItemEdge>
  filters: SearchFilters
  /** A list of nodes. */
  nodes: Array<SearchResultItem>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

/** An edge in a connection. */
export type SearchResultItemEdge = {
  __typename?: 'SearchResultItemEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']
  /** The item at the end of the edge */
  node: SearchResultItem
}

/** Resource types that can be searched */
export const SearchType = {
  /** Search for library resources */
  LibraryResource: 'LIBRARY_RESOURCE',
  /** Search for pages */
  Page: 'PAGE',
  /** Search for parent products */
  ParentProduct: 'PARENT_PRODUCT',
  /** Search for products */
  Product: 'PRODUCT',
} as const

export type SearchType = (typeof SearchType)[keyof typeof SearchType]
/** Manner in which a customer selected a dispensary */
export const SelectDispensaryMethod = {
  PractitionerCode: 'PRACTITIONER_CODE',
  ZipCode: 'ZIP_CODE',
} as const

export type SelectDispensaryMethod =
  (typeof SelectDispensaryMethod)[keyof typeof SelectDispensaryMethod]
/** Site area in which a customer selected a dispensary */
export const SelectDispensarySiteArea = {
  MyAccount: 'MY_ACCOUNT',
  Onboarding: 'ONBOARDING',
} as const

export type SelectDispensarySiteArea =
  (typeof SelectDispensarySiteArea)[keyof typeof SelectDispensarySiteArea]
/** Reference to the original source transaction, such as a Sales Order. */
export type SourceTransaction = {
  __typename?: 'SourceTransaction'
  /** The unique identifier of the source transaction. */
  id: Scalars['ID']
  /** A display-friendly transaction number (e.g., SO1212). */
  number: Scalars['String']
  /** The type of the source transaction (e.g., SalesOrder). */
  type: Scalars['String']
}

/** Onboard request input for a student */
export type StudentOnboardRequestInput = {
  /** Address from which the practitioner operates */
  address: OnboardRequestAddressInput
  /** URL of an uploaded transcript */
  certificateUrl?: InputMaybe<Scalars['String']>
  /** New user's first name */
  firstName: Scalars['String']
  /** Date the student expects to graduate */
  graduationDate: Scalars['String']
  /** New user's last name */
  lastName: Scalars['String']
  /** New user's phone number */
  phone: Scalars['String']
  /** Practitioner's specialty */
  specialty: Scalars['String']
  /** Name of the university the student attends */
  universityName: Scalars['String']
}

export type UpdateEScriptInput = {
  /** The id of the eScript to update. */
  id: Scalars['ID']
  /**
   * The products in the eScript.
   * The sku should be unique within an eScript.
   */
  products?: InputMaybe<Array<NewEScriptProduct>>
  /**
   * The public promo code that is used by a customer to get the discount.
   * Empty string means no promo code, null means no change.
   */
  promoCode?: InputMaybe<Scalars['String']>
}

export type UpdatePayoutMethodAchInput = {
  /** The name of the account holder. */
  accountHolderName?: InputMaybe<Scalars['String']>
  /** The full account number. */
  accountNumber?: InputMaybe<Scalars['String']>
  /** The type of account. */
  accountType?: InputMaybe<AccountType>
  /** The name of the bank. */
  bankName?: InputMaybe<Scalars['String']>
  /** The routing number of the bank. */
  routingNumber?: InputMaybe<Scalars['String']>
}

export type UploadAccountDocumentInput = {
  /** The type of the document. */
  documentType: AccountDocumentType
  /**
   * The url of the document.
   * Example: "s3://some-upload-bucket/path/to/file.pdf"
   */
  documentUrl: Scalars['String']
  /** The name of the file. */
  fileName: Scalars['String']
}

export type SearchAccountDocumentQueryVariables = Exact<{ [key: string]: never }>

export type SearchAccountDocumentQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    accountDocument: Array<{
      __typename?: 'AccountDocument'
      documentType: AccountDocumentType
      fileName: string
      updatedAt: number
    }>
  } | null
}

export type SearchAutoCompleteQueryVariables = Exact<{
  query: Scalars['String']
  limit?: InputMaybe<Scalars['Int']>
}>

export type SearchAutoCompleteQuery = {
  __typename?: 'Query'
  autoComplete: {
    __typename?: 'AutoCompleteResults'
    query: string
    limit: number
    suggestions: Array<string>
    totalCount: number
    results: Array<{
      __typename?: 'IndexedProduct'
      sanityImageJson?: string | null
      sku: string
      id: string
      name: string
      urlKey: string
      labelStatus?: ProductLabelStatus | null
      shortDescription: {
        __typename?: 'DocumentDescription'
        html?: string | null
        text?: string | null
      }
    }>
    aggregations: {
      __typename?: 'AutoCompleteResultsAggregations'
      category?: {
        __typename?: 'AutoCompleteResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'AutoCompleteResultsAggregationOption'
          count?: number | null
          label?: string | null
          value: string
        }>
      } | null
    }
  }
}

export type CustomerAvailableBalanceQueryVariables = Exact<{ [key: string]: never }>

export type CustomerAvailableBalanceQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    availableBalance?: {
      __typename?: 'CustomerAvailableBalance'
      commissionsBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      rebateBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      storeCredit: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      totalBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    } | null
  } | null
}

export type CreateEScriptMutationVariables = Exact<{
  input: CreateEScriptInput
}>

export type CreateEScriptMutation = {
  __typename?: 'Mutation'
  createEScript?: {
    __typename?: 'EScript'
    id: string
    createdAt: number
    description?: string | null
    name: string
    promoCode?: string | null
    updatedAt: number
    products: Array<{
      __typename?: 'EScriptProduct'
      autoShip?: AutoShipOption | null
      quantity: number
      tags?: Array<string> | null
      product?: {
        __typename?: 'Product'
        id: string
        sku: string
        name: string
        mainImage?: { __typename?: 'SanityImage'; url: string } | null
      } | null
    }>
  } | null
}

export type CreateFlexCaptureContextMutationVariables = Exact<{ [key: string]: never }>

export type CreateFlexCaptureContextMutation = {
  __typename?: 'Mutation'
  createFlexCaptureContext: { __typename?: 'FlexCaptureContext'; token: string }
}

export type CreatePaymentInstrumentMutationVariables = Exact<{
  captured: Scalars['String']
  referenceCode: Scalars['String']
}>

export type CreatePaymentInstrumentMutation = {
  __typename?: 'Mutation'
  createPaymentInstrument: string
}

export type DeleteAccountDocumentMutationVariables = Exact<{
  documentType: AccountDocumentType
}>

export type DeleteAccountDocumentMutation = {
  __typename?: 'Mutation'
  deleteAccountDocument?: { __typename?: 'DeleteAccountDocumentPayload'; deletedAt: number } | null
}

export type DeleteEScriptMutationVariables = Exact<{
  id: Scalars['ID']
}>

export type DeleteEScriptMutation = {
  __typename?: 'Mutation'
  deleteEScript?: { __typename?: 'DeleteEScriptPayload'; id?: string | null } | null
}

export type DeletePayoutMethodMutationVariables = Exact<{ [key: string]: never }>

export type DeletePayoutMethodMutation = {
  __typename?: 'Mutation'
  deletePayoutMethod?: { __typename?: 'DeletePayoutMethodPayload'; deletedAt: number } | null
}

export type EScriptQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type EScriptQuery = {
  __typename?: 'Query'
  eScript?: {
    __typename?: 'EScript'
    id: string
    description?: string | null
    promoCode?: string | null
    name: string
    products: Array<{
      __typename?: 'EScriptProduct'
      quantity: number
      tags?: Array<string> | null
      autoShip?: AutoShipOption | null
      product?: {
        __typename?: 'Product'
        id: string
        sku: string
        name: string
        mainImage?: { __typename?: 'SanityImage'; url: string } | null
        parentProduct: { __typename?: 'ParentProduct'; sku: string; urlKey: string }
      } | null
    }>
  } | null
}

export type SearchEScriptsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>
  direction?: InputMaybe<OrderDirection>
  query?: InputMaybe<Scalars['String']>
}>

export type SearchEScriptsQuery = {
  __typename?: 'Query'
  eScripts?: {
    __typename?: 'EScriptConnection'
    edges: Array<{
      __typename?: 'EScriptEdge'
      node: {
        __typename?: 'EScript'
        id: string
        description?: string | null
        name: string
        updatedAt: number
        promoCode?: string | null
        products: Array<{
          __typename?: 'EScriptProduct'
          autoShip?: AutoShipOption | null
          quantity: number
          product?: { __typename?: 'Product'; sku: string } | null
        }>
      }
    }>
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null }
  } | null
}

export type SearchExactParentOrChildSkuQueryVariables = Exact<{
  sku?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type SearchExactParentOrChildSkuQuery = {
  __typename?: 'Query'
  exact: {
    __typename?: 'ExactParentOrChildSkuResults'
    query: string
    limit?: number | null
    suggestions: Array<string>
    totalCount: number
    results: Array<{
      __typename?: 'IndexedProduct'
      advisorTags: Array<string>
      labelStatus?: ProductLabelStatus | null
      sanityImageJson?: string | null
      sanityImageUrl?: string | null
      sku: string
      stockStatus?: IndexedProductStockStatus | null
      id: string
      name: string
      urlKey: string
      shortDescription: {
        __typename?: 'DocumentDescription'
        html?: string | null
        text?: string | null
      }
      description: { __typename?: 'DocumentDescription'; html?: string | null }
      variants?: {
        __typename?: 'IndexedProductVariants'
        summary: {
          __typename?: 'IndexedProductVariantsSummary'
          attributes: Array<IndexedProductVariantAttribute>
          values: {
            __typename?: 'IndexedProductVariantsSummaryValues'
            size?: Array<string> | null
            dosage?: Array<string> | null
            flavor?: Array<string> | null
            flavorSize?: Array<string> | null
          }
        }
      } | null
      priceRange?: {
        __typename?: 'MoneyRange'
        currencyCode: CurrencyCode
        maximum: string
        minimum: string
      } | null
      retailPriceRange?: {
        __typename?: 'MoneyRange'
        currencyCode: CurrencyCode
        maximum: string
        minimum: string
      } | null
    }>
  }
}

export type SearchFacetedQueryVariables = Exact<{
  filters?: InputMaybe<FacetedInputFilters>
  keywords?: InputMaybe<Scalars['String']>
  orderBy?: InputMaybe<Array<ParentProductOrdering> | ParentProductOrdering>
  pagination?: InputMaybe<FacetedInputPagination>
}>

export type SearchFacetedQuery = {
  __typename?: 'Query'
  faceted: {
    __typename?: 'FacetedResults'
    suggestions: Array<string>
    meta: {
      __typename?: 'FacetedResultsMeta'
      count: { __typename?: 'FacetedResultsMetaCount'; all: number; current: number }
      pagination: {
        __typename?: 'FacetedResultsMetaPagination'
        totalPages: number
        currentPage: number
        pageSize: number
      }
    }
    aggregations: {
      __typename?: 'FacetedResultsAggregations'
      category?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
      labelStatus?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
      nameRange?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
      productForm?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
      ingredient?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
      ailment?: {
        __typename?: 'FacetedResultsAggregation'
        id: string
        label?: string | null
        options: Array<{
          __typename?: 'FacetedResultsAggregationOption'
          label?: string | null
          value: string
          count?: number | null
        }>
      } | null
    }
    results: Array<{
      __typename?: 'IndexedProduct'
      id: string
      name: string
      urlKey: string
      advisorTags: Array<string>
      labelStatus?: ProductLabelStatus | null
      sanityImageJson?: string | null
      sanityImageUrl?: string | null
      sku: string
      stockStatus?: IndexedProductStockStatus | null
      priceRange?: {
        __typename?: 'MoneyRange'
        currencyCode: CurrencyCode
        maximum: string
        minimum: string
      } | null
      retailPriceRange?: {
        __typename?: 'MoneyRange'
        currencyCode: CurrencyCode
        maximum: string
        minimum: string
      } | null
      shortDescription: { __typename?: 'DocumentDescription'; html?: string | null }
      description: { __typename?: 'DocumentDescription'; html?: string | null }
      variants?: {
        __typename?: 'IndexedProductVariants'
        summary: {
          __typename?: 'IndexedProductVariantsSummary'
          attributes: Array<IndexedProductVariantAttribute>
          values: {
            __typename?: 'IndexedProductVariantsSummaryValues'
            size?: Array<string> | null
            dosage?: Array<string> | null
            flavor?: Array<string> | null
            flavorSize?: Array<string> | null
          }
        }
      } | null
    }>
  }
}

export type MoneyFragment = { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }

export type NewEScriptFragment = { __typename: 'EScript'; id: string }

export type SearchParentProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']
  labelName: Scalars['String']
  includeLabel: Scalars['Boolean']
}>

export type SearchParentProductBySkuQuery = {
  __typename?: 'Query'
  parentProductBySku?: {
    __typename?: 'ParentProduct'
    id: string
    name: string
    products: {
      __typename?: 'ProductConnection'
      edges: Array<{
        __typename?: 'ProductEdge'
        cursor: string
        node: {
          __typename?: 'Product'
          id: string
          labelStatus?: ProductLabelStatus
          name: string
          sku: string
          price: { __typename?: 'Money'; currencyCode: CurrencyCode; amount: string }
          retailPrice: { __typename?: 'Money'; currencyCode: CurrencyCode; amount: string }
        }
      }>
    }
  } | null
}

export type PayoutMethodAchQueryVariables = Exact<{ [key: string]: never }>

export type PayoutMethodAchQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    payoutMethod?: {
      __typename?: 'PayoutMethodAch'
      accountNumber: string
      bankName: string
      accountType: AccountType
      accountHolderName: string
      routingNumber: string
      updatedAt: number
    } | null
  } | null
}

export type ProductBySkuWithLabelStatusQueryVariables = Exact<{
  sku: Scalars['String']
  labelName: Scalars['String']
}>

export type ProductBySkuWithLabelStatusQuery = {
  __typename?: 'Query'
  productBySku?: {
    __typename?: 'Product'
    id: string
    labelStatus: ProductLabelStatus
    name: string
    sku: string
  } | null
}

export type SearchProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']
}>

export type SearchProductBySkuQuery = {
  __typename?: 'Query'
  productBySku?: {
    __typename?: 'Product'
    id: string
    sku: string
    price: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    retailPrice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    mainImage?: { __typename?: 'SanityImage'; json: string; url: string } | null
  } | null
}

export type ProductsWithParentQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  skus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  orderBy?: InputMaybe<Array<ProductOrdering> | ProductOrdering>
}>

export type ProductsWithParentQuery = {
  __typename?: 'Query'
  products: {
    __typename?: 'ProductConnection'
    nodes: Array<{
      __typename?: 'Product'
      id: string
      sku: string
      parentProduct: { __typename?: 'ParentProduct'; id: string; sku: string }
    }>
  }
}

export type RequestCommissionsPayoutMutationVariables = Exact<{
  input: RewardsPayoutInput
}>

export type RequestCommissionsPayoutMutation = {
  __typename?: 'Mutation'
  requestCommissionsPayout?: { __typename?: 'CommissionsPayout'; success: boolean } | null
}

export type RequestCustomPacketOrderMutationVariables = Exact<{
  input: RequestCustomPacketOrderInput
}>

export type RequestCustomPacketOrderMutation = {
  __typename?: 'Mutation'
  requestCustomPacketOrder: { __typename?: 'CustomPacketOrderRequest'; requestedAt: number }
}

export type RequestRebatesPayoutMutationVariables = Exact<{
  input: RewardsPayoutInput
}>

export type RequestRebatesPayoutMutation = {
  __typename?: 'Mutation'
  requestRebatesPayout?: { __typename?: 'RebatesPayout'; success: boolean } | null
}

export type RewardsAvailableBalanceQueryVariables = Exact<{ [key: string]: never }>

export type RewardsAvailableBalanceQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    availableBalance?: {
      __typename?: 'CustomerAvailableBalance'
      commissionsBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      rebateBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      storeCredit: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      totalBalance: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    } | null
  } | null
}

export type RewardsClassificationAmountsFragment = {
  __typename?: 'RewardsClassificationAmounts'
  dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
}

export type RewardsInvoiceLineFragment = {
  __typename?: 'RewardsTransactionLine'
  memo?: string | null
  quantity?: number | null
  sku: string
  net: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  product?: {
    __typename?: 'Product'
    id: string
    sku: string
    name: string
    mainImage?: { __typename?: 'SanityImage'; json: string; url: string } | null
    parentProduct: { __typename?: 'ParentProduct'; urlKey: string }
  } | null
  rate?: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode } | null
}

export type RewardsInvoiceFragment = {
  __typename?: 'RewardsTransaction'
  id: string
  addressee?: string | null
  classification?: RewardsTransactionClassification | null
  transactionDate: string
  transactionNumber: string
  commissionEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  commissionQualifyingSum: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  discountTotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  lines: Array<{
    __typename?: 'RewardsTransactionLine'
    memo?: string | null
    quantity?: number | null
    sku: string
    net: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    product?: {
      __typename?: 'Product'
      id: string
      sku: string
      name: string
      mainImage?: { __typename?: 'SanityImage'; json: string; url: string } | null
      parentProduct: { __typename?: 'ParentProduct'; urlKey: string }
    } | null
    rate?: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode } | null
  } | null>
  rebateEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  rebateQualifyingSum: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  subtotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  salesTax: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  shippingTotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  sourceTransaction?: {
    __typename?: 'SourceTransaction'
    id: string
    number: string
    type: string
  } | null
  total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
}

export type RewardsInvoicesByIdQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type RewardsInvoicesByIdQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    rewardsTransaction?: {
      __typename?: 'RewardsTransaction'
      id: string
      addressee?: string | null
      classification?: RewardsTransactionClassification | null
      transactionDate: string
      transactionNumber: string
      commissionEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      commissionQualifyingSum: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      discountTotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      lines: Array<{
        __typename?: 'RewardsTransactionLine'
        memo?: string | null
        quantity?: number | null
        sku: string
        net: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        product?: {
          __typename?: 'Product'
          id: string
          sku: string
          name: string
          mainImage?: { __typename?: 'SanityImage'; json: string; url: string } | null
          parentProduct: { __typename?: 'ParentProduct'; urlKey: string }
        } | null
        rate?: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode } | null
      } | null>
      rebateEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      rebateQualifyingSum: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      subtotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      salesTax: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      shippingTotal: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      sourceTransaction?: {
        __typename?: 'SourceTransaction'
        id: string
        number: string
        type: string
      } | null
      total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    } | null
  } | null
}

export type RewardsInvoicesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>
  classification?: InputMaybe<
    Array<RewardsTransactionClassification> | RewardsTransactionClassification
  >
  dateRange?: InputMaybe<DateRangeInput>
}>

export type RewardsInvoicesQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    rewardsTransactions?: {
      __typename?: 'RewardsTransactionConnection'
      edges: Array<{
        __typename?: 'RewardsTransactionEdge'
        cursor: string
        node: {
          __typename?: 'RewardsTransaction'
          id: string
          addressee?: string | null
          classification?: RewardsTransactionClassification | null
          tags: Array<CustomerOrderTag>
          transactionDate: string
          transactionNumber: string
          commissionEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          commissionQualifyingSum: {
            __typename?: 'Money'
            amount: string
            currencyCode: CurrencyCode
          }
          rebateEarned: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          rebateQualifyingSum: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        }
      }>
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null }
    } | null
  } | null
}

export type RewardsPeriodsQueryVariables = Exact<{ [key: string]: never }>

export type RewardsPeriodsQuery = {
  __typename?: 'Query'
  customer?: { __typename?: 'Customer'; rewardsPeriods: Array<string> } | null
}

export type RewardsRetailClassificationAmountsFragment = {
  __typename?: 'RewardsRetailClassificationAmounts'
  dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
}

export type RewardsSnapshotByPeriodQueryVariables = Exact<{
  period: Scalars['RewardsPeriod']
}>

export type RewardsSnapshotByPeriodQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    rewardsSnapshotByPeriod?: {
      __typename?: 'RewardsSnapshot'
      commissionsStatus: RewardsStatus
      id: string
      level: RewardsLevel
      period: string
      rebateStatus: RewardsStatus
      commissionsEarned: {
        __typename?: 'RewardsRetailClassificationAmounts'
        dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
      commissionsQualifyingSales: {
        __typename?: 'RewardsRetailClassificationAmounts'
        dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
      orderCounts: {
        __typename?: 'RewardsOrderCounts'
        total: number
        retail: number
        wholesale: number
      }
      rebateEarned: {
        __typename?: 'RewardsClassificationAmounts'
        dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
      rebateQualifyingSales: {
        __typename?: 'RewardsClassificationAmounts'
        dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
      tierQualifyingSales: {
        __typename?: 'RewardsClassificationAmounts'
        dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
      totalEarned: {
        __typename?: 'RewardsTotalAmounts'
        total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
      }
    } | null
  } | null
}

export type RewardsSnapshotFragment = {
  __typename?: 'RewardsSnapshot'
  commissionsStatus: RewardsStatus
  id: string
  level: RewardsLevel
  period: string
  rebateStatus: RewardsStatus
  commissionsEarned: {
    __typename?: 'RewardsRetailClassificationAmounts'
    dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
  commissionsQualifyingSales: {
    __typename?: 'RewardsRetailClassificationAmounts'
    dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
  orderCounts: {
    __typename?: 'RewardsOrderCounts'
    total: number
    retail: number
    wholesale: number
  }
  rebateEarned: {
    __typename?: 'RewardsClassificationAmounts'
    dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
  rebateQualifyingSales: {
    __typename?: 'RewardsClassificationAmounts'
    dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
  tierQualifyingSales: {
    __typename?: 'RewardsClassificationAmounts'
    dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
    wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
  totalEarned: {
    __typename?: 'RewardsTotalAmounts'
    total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
  }
}

export type RewardsLatestSnapshotsQueryVariables = Exact<{
  latestCount?: InputMaybe<Scalars['Int']>
}>

export type RewardsLatestSnapshotsQuery = {
  __typename?: 'Query'
  customer?: {
    __typename?: 'Customer'
    rewardsSnapshots?: {
      __typename?: 'RewardsSnapshotConnection'
      nodes: Array<{
        __typename?: 'RewardsSnapshot'
        id: string
        level: RewardsLevel
        period: string
        commissionsEarned: {
          __typename?: 'RewardsRetailClassificationAmounts'
          dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        }
        orderCounts: { __typename?: 'RewardsOrderCounts'; total: number }
        rebateEarned: {
          __typename?: 'RewardsClassificationAmounts'
          dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        }
        tierQualifyingSales: {
          __typename?: 'RewardsClassificationAmounts'
          dfhWebStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          eStore: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          inPractice: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          retail: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          wellWorld: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
          wholesale: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        }
        totalEarned: {
          __typename?: 'RewardsTotalAmounts'
          total: { __typename?: 'Money'; amount: string; currencyCode: CurrencyCode }
        }
      }>
      pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean }
    } | null
  } | null
}

export type UpdateEScriptMutationVariables = Exact<{
  input: UpdateEScriptInput
}>

export type UpdateEScriptMutation = {
  __typename?: 'Mutation'
  updateEScript?: {
    __typename?: 'EScript'
    id: string
    createdAt: number
    description?: string | null
    name: string
    promoCode?: string | null
    updatedAt: number
    products: Array<{
      __typename?: 'EScriptProduct'
      autoShip?: AutoShipOption | null
      quantity: number
      tags?: Array<string> | null
      product?: {
        __typename?: 'Product'
        id: string
        sku: string
        name: string
        mainImage?: { __typename?: 'SanityImage'; url: string } | null
      } | null
    }>
  } | null
}

export type UpdatePayoutMethodAchMutationVariables = Exact<{
  input: UpdatePayoutMethodAchInput
}>

export type UpdatePayoutMethodAchMutation = {
  __typename?: 'Mutation'
  updatePayoutMethodAch?: {
    __typename?: 'PayoutMethodAch'
    accountNumber: string
    bankName: string
    accountType: AccountType
    accountHolderName: string
    routingNumber: string
    updatedAt: number
  } | null
}

export type UploadAccountDocumentMutationVariables = Exact<{
  input: UploadAccountDocumentInput
}>

export type UploadAccountDocumentMutation = {
  __typename?: 'Mutation'
  uploadAccountDocument?: {
    __typename?: 'AccountDocument'
    documentType: AccountDocumentType
    fileName: string
    updatedAt: number
  } | null
}

export const NewEScriptFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewEScript' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EScript' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewEScriptFragment, unknown>
export const MoneyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoneyFragment, unknown>
export const RewardsInvoiceLineFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsInvoiceLine' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsTransactionLine' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'memo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'net' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'urlKey' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsInvoiceLineFragment, unknown>
export const RewardsInvoiceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsInvoice' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionQualifyingSum' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountTotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'rewardsInvoiceLine' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateQualifyingSum' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingTotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sourceTransaction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsInvoiceLine' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsTransactionLine' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'memo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'net' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'urlKey' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsInvoiceFragment, unknown>
export const RewardsRetailClassificationAmountsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsRetailClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsRetailClassificationAmountsFragment, unknown>
export const RewardsClassificationAmountsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inPractice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wholesale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsClassificationAmountsFragment, unknown>
export const RewardsSnapshotFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsSnapshot' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsSnapshot' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionsEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionsQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'commissionsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wholesale' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'period' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rebateStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsRetailClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inPractice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wholesale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsSnapshotFragment, unknown>
export const SearchAccountDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchAccountDocument' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchAccountDocumentQuery, SearchAccountDocumentQueryVariables>
export const SearchAutoCompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchAutoComplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoComplete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enableFullCatalog' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'query' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urlKey' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelStatus' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'IndexedProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortDescription' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'sanityImageJson' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchAutoCompleteQuery, SearchAutoCompleteQueryVariables>
export const CustomerAvailableBalanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'customerAvailableBalance' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableBalance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commissionsBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rebateBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'storeCredit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerAvailableBalanceQuery, CustomerAvailableBalanceQueryVariables>
export const CreateEScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateEScriptInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'autoShip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEScriptMutation, CreateEScriptMutationVariables>
export const CreateFlexCaptureContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createFlexCaptureContext' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFlexCaptureContext' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'token' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFlexCaptureContextMutation,
  CreateFlexCaptureContextMutationVariables
>
export const CreatePaymentInstrumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPaymentInstrument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'captured' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentInstrument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'captured' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'captured' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceCode' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePaymentInstrumentMutation,
  CreatePaymentInstrumentMutationVariables
>
export const DeleteAccountDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAccountDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccountDocumentType' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAccountDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAccountDocumentMutation, DeleteAccountDocumentMutationVariables>
export const DeleteEScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteEScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEScriptMutation, DeleteEScriptMutationVariables>
export const DeletePayoutMethodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePayoutMethod' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePayoutMethod' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePayoutMethodMutation, DeletePayoutMethodMutationVariables>
export const EScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoShip' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'parentProduct' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'urlKey' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EScriptQuery, EScriptQueryVariables>
export const SearchEScriptsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchEScripts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'direction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderDirection' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eScripts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'field' },
                          value: { kind: 'EnumValue', value: 'UPDATED_AT' },
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'direction' },
                          value: { kind: 'Variable', name: { kind: 'Name', value: 'direction' } },
                        },
                      ],
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'promoCode' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'products' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'autoShip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchEScriptsQuery, SearchEScriptsQueryVariables>
export const SearchExactParentOrChildSkuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchExactParentOrChildSku' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sku' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enableFullCatalog' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'query' } },
                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'retailPriceRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'urlKey' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'IndexedProduct' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortDescription' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'advisorTags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'labelStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sanityImageJson' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sanityImageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stockStatus' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'summary' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'values' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'size' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'dosage' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'flavor' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'flavorSize' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchExactParentOrChildSkuQuery,
  SearchExactParentOrChildSkuQueryVariables
>
export const SearchFacetedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchFaceted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetedInputFilters' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ParentProductOrdering' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetedInputPagination' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'faceted' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enableFullCatalog' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'all' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labelStatus' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productForm' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ingredient' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ailment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'options' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'results' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'urlKey' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'retailPriceRange' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minimum' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortDescription' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'html' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'html' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'advisorTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sanityImageJson' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sanityImageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stockStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'variants' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'summary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'attributes' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'dosage' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'flavor' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'flavorSize' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchFacetedQuery, SearchFacetedQueryVariables>
export const SearchParentProductBySkuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchParentProductBySku' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labelName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeLabel' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parentProductBySku' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sku' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '10' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'labelStatus' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'labelName' },
                                        value: {
                                          kind: 'Variable',
                                          name: { kind: 'Name', value: 'labelName' },
                                        },
                                      },
                                    ],
                                    directives: [
                                      {
                                        kind: 'Directive',
                                        name: { kind: 'Name', value: 'include' },
                                        arguments: [
                                          {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'if' },
                                            value: {
                                              kind: 'Variable',
                                              name: { kind: 'Name', value: 'includeLabel' },
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currencyCode' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'retailPrice' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'currencyCode' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchParentProductBySkuQuery, SearchParentProductBySkuQueryVariables>
export const PayoutMethodAchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'payoutMethodAch' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payoutMethod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PayoutMethodAch' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accountNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountHolderName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'routingNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PayoutMethodAchQuery, PayoutMethodAchQueryVariables>
export const ProductBySkuWithLabelStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'productBySkuWithLabelStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labelName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productBySku' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sku' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelStatus' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'labelName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'labelName' } },
                    },
                  ],
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProductBySkuWithLabelStatusQuery,
  ProductBySkuWithLabelStatusQueryVariables
>
export const SearchProductBySkuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchProductBySku' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productBySku' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sku' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retailPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchProductBySkuQuery, SearchProductBySkuQueryVariables>
export const ProductsWithParentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'productsWithParent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skus' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductOrdering' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'products' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentProduct' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductsWithParentQuery, ProductsWithParentQueryVariables>
export const RequestCommissionsPayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestCommissionsPayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsPayoutInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestCommissionsPayout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestCommissionsPayoutMutation,
  RequestCommissionsPayoutMutationVariables
>
export const RequestCustomPacketOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestCustomPacketOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RequestCustomPacketOrderInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestCustomPacketOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestCustomPacketOrderMutation,
  RequestCustomPacketOrderMutationVariables
>
export const RequestRebatesPayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'requestRebatesPayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsPayoutInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestRebatesPayout' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestRebatesPayoutMutation, RequestRebatesPayoutMutationVariables>
export const RewardsAvailableBalanceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsAvailableBalance' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableBalance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commissionsBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rebateBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'storeCredit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalBalance' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsAvailableBalanceQuery, RewardsAvailableBalanceQueryVariables>
export const RewardsInvoicesByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsInvoicesById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsTransaction' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'rewardsInvoice' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsInvoiceLine' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsTransactionLine' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'memo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'net' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'product' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'json' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parentProduct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'urlKey' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsInvoice' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'classification' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionQualifyingSum' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discountTotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'rewardsInvoiceLine' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateQualifyingSum' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'salesTax' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingTotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sourceTransaction' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtotal' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'transactionNumber' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsInvoicesByIdQuery, RewardsInvoicesByIdQueryVariables>
export const RewardsInvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsInvoices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classification' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'RewardsTransactionClassification' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateRangeInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsTransactions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '10' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'after' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'classification' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'classification' } },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'dateRange' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressee' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'classification' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'commissionEarned' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'commissionQualifyingSum' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rebateEarned' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rebateQualifyingSum' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'transactionDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'transactionNumber' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsInvoicesQuery, RewardsInvoicesQueryVariables>
export const RewardsPeriodsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsPeriods' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'rewardsPeriods' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsPeriodsQuery, RewardsPeriodsQueryVariables>
export const RewardsSnapshotByPeriodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsSnapshotByPeriod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsPeriod' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsSnapshotByPeriod' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'period' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'rewardsSnapshot' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsRetailClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inPractice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wholesale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsSnapshot' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RewardsSnapshot' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionsEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'commissionsQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'commissionsStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'level' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'retail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wholesale' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'period' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rebateQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rebateStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tierQualifyingSales' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalEarned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'total' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsSnapshotByPeriodQuery, RewardsSnapshotByPeriodQueryVariables>
export const RewardsLatestSnapshotsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'rewardsLatestSnapshots' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'latestCount' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '6' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rewardsSnapshots' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'latestCount' } },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commissionsEarned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'rewardsRetailClassificationAmounts',
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderCounts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rebateEarned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tierQualifyingSales' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEarned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'money' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'money' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Money' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsRetailClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsRetailClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'rewardsClassificationAmounts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RewardsClassificationAmounts' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dfhWebStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eStore' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inPractice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellWorld' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wholesale' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'money' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RewardsLatestSnapshotsQuery, RewardsLatestSnapshotsQueryVariables>
export const UpdateEScriptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEScript' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEScriptInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEScript' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'autoShip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEScriptMutation, UpdateEScriptMutationVariables>
export const UpdatePayoutMethodAchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePayoutMethodAch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdatePayoutMethodAchInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePayoutMethodAch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bankName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountHolderName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routingNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePayoutMethodAchMutation, UpdatePayoutMethodAchMutationVariables>
export const UploadAccountDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadAccountDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UploadAccountDocumentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadAccountDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadAccountDocumentMutation, UploadAccountDocumentMutationVariables>
